import React from "react";
import styled from "styled-components";
import Moment from "react-moment";
import Icon from "./Icon";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverContentItem
} from "./Popover";
import { EXTERNAL_OPEN, MORE } from "../icons";
import downloadFile from "../utils/download";
import * as colors from "../settings/colors";
import joinPath from "../utils/join-path";

const Title = styled.a`
  display: block;
  font-weight: 600;
  cursor: pointer;
  color: ${colors.TEXT};
  text-decoration: none;

  &:hover {
    color: ${colors.BLUE};
    text-decoration: underline;
  }
`;

const SecondaryText = styled.div`
  color: ${colors.TEXT_SECONDARY};
  font-size: 12px;
  margin-top: 4px;
`;

const Actions = styled.div`
  position: absolute;
  display: flex;
  top: 4px;
  right: 4px;
  padding: 8px;
  background: #fff;
  border-radius: 4px;

  & svg {
    fill: ${colors.TAB_TEXT};
  }

  & svg:hover {
    cursor: pointer;
    fill: ${colors.BLUE};
  }

  & ${PopoverTrigger}:focus {
    box-shadow: none;
  }
`;

const AttachmentWrapper = styled.div`
  position: relative;
  border: 1px solid ${colors.DIVIDER};
  border-radius: 4px;
  padding: 12px;
  margin: 8px 0;
`;

const Attachment = ({
  attachment,
  deleteAttachment,
  openPreview,
  match,
  history
}) => {
  const handleSelection = value => {
    value();
  };

  const attachmentLink =
    attachment.attachmentType === "TRANSMITTAL" && attachment.transmittal
      ? joinPath(match.url, "/transmittals/" + attachment.transmittal.id)
      : attachment.versions.original;

  const downloadAttachment = () => {
    downloadFile(
      attachmentLink,
      attachment.originalFilename || attachment.name
    );
  };

  const openTransmittal = e => {
    if (e) e.preventDefault();

    if (attachment.attachmentType === "TRANSMITTAL") {
      history.push(attachmentLink);
    } else {
      window.location.href = attachmentLink;
    }
  };

  const isDownloadable = attachment.attachmentType !== "TRANSMITTAL";

  return (
    <AttachmentWrapper>
      <Title onClick={openTransmittal}>{attachment.name}</Title>
      {attachment.uploader && (
        <SecondaryText>{attachment.uploader.name}</SecondaryText>
      )}
      <SecondaryText>
        <Moment format="MMM Do [at] h:mm a">{attachment.createdAt}</Moment>
      </SecondaryText>
      <Actions>
        {attachment.versions.original && (
          <a href={attachmentLink} target="_blank" style={{ marginRight: 4 }}>
            <Icon icon={EXTERNAL_OPEN} />
          </a>
        )}
        <Popover onSelection={handleSelection}>
          <PopoverTrigger>
            <Icon icon={MORE} />
          </PopoverTrigger>
          <PopoverContent>
            {isDownloadable && (
              <PopoverContentItem value={downloadAttachment}>
                Download file
              </PopoverContentItem>
            )}
            <PopoverContentItem
              value={() => deleteAttachment(attachment)}
              color={colors.RED}
            >
              Delete attachment...
            </PopoverContentItem>
          </PopoverContent>
        </Popover>
      </Actions>
    </AttachmentWrapper>
  );
};

export default Attachment;



// WEBPACK FOOTER //
// ./src/components/Attachment.js